import React from 'react';
import {
  Banknote, FileText, Clock, ShieldCheck, Bot, Sparkles, BadgeCheck, Landmark,
  BarChart3, Mail, Upload, Server, ScanLine, Database, CreditCard, FileCheck,
  FileSpreadsheet, Receipt, RefreshCw, Wallet, Leaf, Target, Sun, LifeBuoy,
  ClipboardCheck, Rocket, Workflow, Plug, Users, Network, Building2, Factory,
  Briefcase, Home, Layers, AlertTriangle, Globe, TrendingUp, FileSignature,
  Search, DatabaseZap, BatteryCharging, Lock, Zap, Flame, Droplets, Trash2,
  Wind, CheckCircle2, Gauge, PieChart, LineChart, Cpu, Eye, Bell, Linkedin, MapPin,
  ListChecks, GaugeCircle, BookOpenCheck,
} from 'lucide-react';

const MAP = {
  Linkedin, MapPin, ListChecks, GaugeCircle, BookOpenCheck,
  Banknote, FileText, Clock, ShieldCheck, Bot, Sparkles, BadgeCheck, Landmark,
  BarChart3, Mail, Upload, Server, ScanLine, Database, CreditCard, FileCheck,
  FileSpreadsheet, Receipt, RefreshCw, Wallet, Leaf, Target, Sun, LifeBuoy,
  ClipboardCheck, Rocket, Workflow, Plug, Users, Network, Building2, Factory,
  Briefcase, Home, Layers, AlertTriangle, Globe, TrendingUp, FileSignature,
  Search, DatabaseZap, BatteryCharging, Lock, Zap, Flame, Droplets, Trash2,
  Wind, CheckCircle2, Gauge, PieChart, LineChart, Cpu, Eye, Bell,
};

export default function Icon({ name, className, ...rest }) {
  const Cmp = MAP[name] || Sparkles;
  return <Cmp className={className} {...rest} />;
}
